import { IAdminStats } from "@/api";
import { TotalPaper } from "@/components/shared/layout/TotalPaper";
import { Stack } from "@mui/material";

interface ITotals {
    total: number;
    title: string;
}

interface IProps {
    stats: IAdminStats;
}

export const TotalsContainer = ({ stats }: IProps) => {
    const totals: ITotals[] = [
        { total: stats.scopes, title: "Total Scopes" },
        { total: stats.users, title: "Total Users" },
        { total: stats.clause_checklists.length, title: "Clause Checklists" },
    ];

    return (
        <Stack
            direction={"row"}
            spacing={{ xs: 2, lg: 3 }}
            width={"100%"}
            height={"100%"}
            maxHeight={{ xs: 110, lg: 200 }}
        >
            {totals.map((total) => (
                <TotalPaper
                    key={total.title}
                    total={total.total}
                    title={total.title}
                />
            ))}
        </Stack>
    );
};
